var exports = {
  "az": "Box__POkMBc",
  "Ik": "fullHeightContainer__vN0suF",
  "I1": "fullHeightBox__0V0UZ6",
  "wy": "Box_1__WeHk4Y",
};

module.exports = exports;
